module.exports = __webpack_public_path__ + "static/media/ayunda.45f517b5.jpeg";